import { Component, ElementRef, EventEmitter, HostListener, inject, OnDestroy, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { Dialog } from '@angular/cdk/dialog';
import { AppMenuService, getUrl } from '@cumlaude/shared-components-menu';
import { IconComponent } from '@cumlaude/shared-components-icons';

@Component({
	selector: 'app-tab-menu',
	templateUrl: './tab-menu.component.html',
	styleUrls: ['./tab-menu.component.scss'],
	imports: [RouterLinkActive, RouterLink, IconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabMenuComponent implements OnDestroy {
	readonly dialog = inject(Dialog);
	readonly appMenuService = inject(AppMenuService);

	private readonly subscriptions: Subscription[] = [];

	private readonly scrollCheck$ = new EventEmitter<void>();

	@ViewChild('viewport')
	viewport?: ElementRef;

	showLeft = false;
	showRight = false;

	constructor() {
		const router = inject(Router);

		this.subscriptions.push(
			router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
				this.scrollCheck$.emit();
			}),
			// het debouncen dient 2 doelen:
			// 1. niet zo veel render loops tijdens het resizen
			// 2. bij een nieuwe route wachten totdat render loop uitgevoerd is en we de clientWidth weten
			this.scrollCheck$.pipe(debounceTime(50)).subscribe(() => this.calcScrollButtons())
		);
	}

	@HostListener('window:resize')
	onWindowResize() {
		this.scrollCheck$.emit();
	}

	calcScrollButtons() {
		const elt = this.viewport?.nativeElement;
		if (!elt) return;

		this.showLeft = elt.scrollLeft > 0;
		this.showRight = elt.scrollWidth > elt.scrollLeft + elt.clientWidth;
	}

	scrollLeft() {
		const elt = this.viewport?.nativeElement;
		if (!elt) return;

		elt.scrollLeft = Math.max(0, elt.scrollLeft - elt.clientWidth);
		this.calcScrollButtons();
	}

	scrollRight() {
		const elt = this.viewport?.nativeElement;
		if (!elt) return;

		elt.scrollLeft = Math.min(elt.scrollLeft + elt.clientWidth, elt.scrollWidth - elt.clientWidth);
		this.calcScrollButtons();
	}

	ngOnDestroy() {
		for (const sub of this.subscriptions) sub.unsubscribe();
	}

	protected readonly getUrl = getUrl;
}
